import { RootState } from "core-integration/src/store";
import { getElements } from "core-integration/src/store/elements/reducers";
import { IElement } from "core-integration/src/store/elements/types";
import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Title from "../Title";
import EventInfo from "./EventInfo";
import GameweekScheduleTracker from "./GameweekScheduleTracker";
import InjuryTracker from "./InjuryTracker";
import TopScorers from "./TopScorers";
import TransfersPanel from "./TransfersPanel";
import NbaNewsProvider from "../news/NbaNewsProvider";

const TitleWrap = styled.div`
  margin-top: ${({ theme }) => theme.space[4]};
  margin-bottom: ${({ theme }) => theme.space[2]};
  padding-left: ${({ theme }) => theme.space[2]};
  padding-right: ${({ theme }) => theme.space[2]};
`;

const SectionSpacer = styled.div`
  margin-bottom: ${({ theme }) => theme.space[8]};
`;

const StatusWrapper = styled.div`
  max-width: 1220px;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding-right: ${({ theme }) => theme.space[2]};
    padding-left: ${({ theme }) => theme.space[2]};
  }
`;

const StatusCols = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    display: flex;
    justify-content: space-between;
    gap: 10rem;
  }
`;

const Status: React.FC = () => {
  const { t } = useTranslation();
  const now = useSelector(getCurrentEvent);
  const player = useSelector((state: RootState) => getPlayerData(state));
  const elements = useSelector((state: RootState) => getElements(state));
  const teamsById = useSelector(getTeamsById);

  if (!player) {
    return null;
  }

  const groupedElements: { front_court: IElement[]; back_court: IElement[] } = {
    front_court: [],
    back_court: [],
  };

  Object.values(elements).forEach((element: IElement) => {
    if (element.element_type === 2) {
      groupedElements.front_court.push(element);
    } else if (element.element_type === 1) {
      groupedElements.back_court.push(element);
    }
  });

  return (
    <StatusWrapper>
      <TitleWrap>
        {now && (
          <Title>
            {t("status.titleN", "{{name}} Status", { name: `${now.name}` })}
          </Title>
        )}
      </TitleWrap>
      {now && (
        <SectionSpacer>
          <EventInfo />
        </SectionSpacer>
      )}
      <SectionSpacer>
        <NbaNewsProvider numberOfArticles={10} />
      </SectionSpacer>
      {now && <TopScorers elements={elements} />}
      <SectionSpacer>
        <GameweekScheduleTracker />
      </SectionSpacer>
      {now && (
        <StatusCols>
          <SectionSpacer>
            <TransfersPanel />
          </SectionSpacer>
          <SectionSpacer>
            <TransfersPanel isOut={true} />
          </SectionSpacer>
        </StatusCols>
      )}
      <SectionSpacer>
        <InjuryTracker
          newsCount={5}
          showLink={true}
          borderBottom={true}
          teamsById={teamsById}
          elements={elements}
        />
      </SectionSpacer>
    </StatusWrapper>
  );
};

export default Status;
